module.exports = __webpack_public_path__ + "static/media/eye.0645bbe4.svg";